import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.83833} fill="#E7EBFA" />
    <G clipPath="url(#clip0_1120_7767)">
      <Path
        opacity={0.2}
        d="M18.2501 21.9228L15.4986 19.25C15.405 19.1658 15.3341 19.0593 15.2925 18.9405C15.2508 18.8217 15.2398 18.6943 15.2603 18.5701C15.2809 18.4459 15.3324 18.3288 15.41 18.2297C15.4877 18.1306 15.5891 18.0527 15.7048 18.0031L16.3751 17.75L21.7686 19.7347L26.9098 16.6644C27.527 16.3012 28.2537 16.1707 28.9586 16.2966C29.6636 16.4224 30.3002 16.7963 30.7536 17.3506L32.5001 19.5912L18.6805 27.8412C18.1222 28.1663 17.4739 28.3025 16.832 28.2295C16.1902 28.1565 15.589 27.8783 15.118 27.4362L11.7373 24.125C11.6464 24.0398 11.5782 23.9332 11.5387 23.815C11.4993 23.6968 11.49 23.5706 11.5116 23.4479C11.5332 23.3251 11.585 23.2097 11.6624 23.112C11.7398 23.0144 11.8403 22.9375 11.9548 22.8884L12.2501 22.744L15.2305 23.75L18.2501 21.9228Z"
        fill="#1434CB"
      />
      <Path
        d="M12.25 31.25H25.75"
        stroke="#1434CB"
        strokeWidth={1.375}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M18.2501 21.9228L15.4986 19.25C15.405 19.1658 15.3341 19.0593 15.2925 18.9405C15.2508 18.8217 15.2398 18.6943 15.2603 18.5701C15.2809 18.4459 15.3324 18.3288 15.41 18.2297C15.4877 18.1306 15.5891 18.0527 15.7048 18.0031L16.3751 17.75L21.7686 19.7347L26.9098 16.6644C27.527 16.3012 28.2537 16.1707 28.9586 16.2966C29.6636 16.4224 30.3002 16.7963 30.7536 17.3506L32.5001 19.5912L18.6805 27.8412C18.1222 28.1663 17.4739 28.3025 16.832 28.2295C16.1902 28.1565 15.589 27.8783 15.118 27.4362L11.7373 24.125C11.6464 24.0398 11.5782 23.9332 11.5387 23.815C11.4993 23.6968 11.49 23.5706 11.5116 23.4479C11.5332 23.3251 11.585 23.2097 11.6624 23.112C11.7398 23.0144 11.8403 22.9375 11.9548 22.8884L12.2501 22.744L15.2305 23.75L18.2501 21.9228Z"
        stroke="#1434CB"
        strokeWidth={1.375}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1120_7767">
        <Rect
          width={24}
          height={24}
          fill="white"
          transform="translate(10 11)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
